<div class="question-wrapper-thumb" *ngIf="displayMode === 'Vertical'">
  <div class="div-content sentence-align">
    <ng-component class="editor" [innerHTML]="sanitizer.bypassSecurityTrustHtml(questions?.questiondescription?.description)"></ng-component>
  </div>
  <div class="like-dislike" [ngClass]="displayMode === 'Vertical' ? 'd-block': ''">
    <input type="radio" disabled name="like-dislike" id="thumbs-up">
    <span class="glyphicon glyphicon-thumbs-up"></span>
  </div>
  <div class="like-dislike" [ngClass]="displayMode === 'Vertical' ? 'd-block': ''">
    <input type="radio" disabled name="like-dislike" id="thumbs-up">
    <span class="glyphicon thumbs-down glyphicon-thumbs-down"></span>
  </div>
</div>

<div class="question-wrapper-thumb horizontal-view-radio" *ngIf="displayMode != 'Vertical'">
  <div class="col-w-40">
    <div class="div-content sentence-align">
      <ng-component class="editor-question" [innerHTML]="sanitizer.bypassSecurityTrustHtml(questions?.questiondescription?.description)"></ng-component>
    </div>
  </div>

  <div class="col-w-60">
    <div class="like-dislike">
      <input type="radio" disabled name="like-dislike" id="thumbs-up">
      <span class="glyphicon glyphicon-thumbs-up"></span>
    </div>
    <div class="like-dislike">
      <input type="radio" disabled name="like-dislike" id="thumbs-up">
      <span class="glyphicon thumbs-down glyphicon-thumbs-down"></span>
    </div>
  </div>
</div>
